/**
 * @file: 客户 邮箱认证 显示组件
 * IconDirectPo
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/12/10      1.0     First version
 *
 * verifyEmailStatus : 1:已验证 2:邮件已发送 3:邮箱地址无效 4:邮件发送失败 5:未知
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import {  Tooltip } from 'antd';
import Lang from "@components/Lang/Lang";
const getIcon =(verifyEmailStatus,size)=>{
    let tips="", icon = ""
    switch (verifyEmailStatus) {
        case "1":
            tips=  Lang({id:"YouXiangYiYanZheng",default:"邮箱已验证"});
            icon = (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 18" fill="none">
                <path d="M13.95 18L9.7 13.75L11.1 12.35L13.95 15.2L19.6 9.55L21 10.95L13.95 18ZM10 7L18 2H2L10 7ZM10 9L2 4V14H7.15L9.15 16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196667 15.0217 0.000666667 14.5507 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196666 1.45067 0.000666667 2 0H18C18.55 0 19.021 0.196 19.413 0.588C19.805 0.98 20.0007 1.45067 20 2V6.35L18 8.35V4L10 9Z" fill="#27AD60"/>
            </svg>);
            break;
        case "2":
            tips = Lang({id:"YouXiangYiChengGongJieSho",default:"邮箱已成功接收邮件，但用户未完成验证"});
            icon = (<span className={`ri-mail-unread-line font-orange`} style={{fontSize:size+"px"}} />);
            break;
        case "3":
            tips=  Lang({id:"YouXiangDiZhiWuXiao",default:"邮箱地址无效"});
            icon = (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 21" fill="none">
                <path d="M21 19.8L1.3 0L0 1.3L1.5 2.8C1.2 3.2 0.9 3.7 0.9 4.3V16.3C0.9 17.4 1.8 18.3 2.9 18.3H17L19.7 21L21 19.8ZM2.9 16.3V6.3L8.5 9.8L15 16.3H2.9ZM8.1 4.3L6.1 2.3H18.9C20 2.3 20.9 3.2 20.9 4.3V16.3C20.9 16.5 20.9 16.8 20.8 17L18.9 15.1V6.3L13.5 9.7L12.3 8.5L18.9 4.3H8.1Z" fill="black" fill-opacity="0.66"/>
            </svg>);
            break;
        case "4":
            tips=  Lang({id:"YouJianFaSongShiBai",default:"邮件发送失败"});
            icon = (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22 17" fill="none">
                <path d="M21 8.5V1H1V16H11M19 12L15 16M15 12L19 16" stroke="#E6521F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 1L11 8.5L21 1" stroke="#E6521F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>);
            break;
        default:
            tips=  Lang({id:"WeiZhi",default:"未知"});
            icon = (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 21" fill="none">
                <path d="M21 19.8L1.3 0L0 1.3L1.5 2.8C1.2 3.2 0.9 3.7 0.9 4.3V16.3C0.9 17.4 1.8 18.3 2.9 18.3H17L19.7 21L21 19.8ZM2.9 16.3V6.3L8.5 9.8L15 16.3H2.9ZM8.1 4.3L6.1 2.3H18.9C20 2.3 20.9 3.2 20.9 4.3V16.3C20.9 16.5 20.9 16.8 20.8 17L18.9 15.1V6.3L13.5 9.7L12.3 8.5L18.9 4.3H8.1Z" fill="black" fill-opacity="0.66"/>
            </svg>);
            break;
    }
    return {
        tips:tips,
        icon:icon
    }
}
const CustomerEmailStatus = ({verifyEmailStatus="",size=21}) => {
    const emailStatus = getIcon(verifyEmailStatus,size);
    return (<Tooltip title={emailStatus.tips} placement="top" overlayStyle={{maxWidth:"400px"}}>
        {emailStatus.icon}
    </Tooltip>)
}

export default CustomerEmailStatus;
